/**
 * The event types a webhook may subscribe to, as the API names them. Kept
 * here rather than imported, so the console bundles nothing from the
 * server; a test holds it to the API's own list.
 */
export const WEBHOOK_EVENTS = [
  'claim.made', 'claim.released', 'ask.received', 'ask.withdrawn', 'ask.answered', 'relay.acted',
] as const;
